import { captureException } from "@sentry/browser";

function report(
  error: unknown,
  entryName: string,
  fnName: string,
  extra?: Record<string, unknown>,
): void {
  captureException(error, {
    tags: {
      entry_call: entryName,
      function_failed: fnName,
    },
    extra,
  });
}

export function safeCall(
  fn: () => void | Promise<void>,
  entryName: string,
  fnName?: string,
  extra?: Record<string, unknown>,
): void {
  try {
    const result = fn();
    if (result instanceof Promise) {
      result.catch((e: unknown) => {
        report(e, entryName, fnName ?? fn.name, extra);
      });
    }
  } catch (e: unknown) {
    report(e, entryName, fnName ?? fn.name, extra);
  }
}
